<script>
export let headline;
export let description;
export let image;
export let video;
export let what;
export let tools;
export let where;
export let maxWidth;
</script>

<style>
.LinkLayoutC {
    text-align: center;
}
.LinkLayoutC video,
.LinkLayoutC img {
    margin-top: 0px;
    margin-right: 0px;
    margin-left: 0px;
    width: 100%;
}
</style>

<div class="LinkLayoutC">
    {#if image}
        <img src="{image}" alt="Promo for {headline}" style="max-width: {maxWidth}px"/>
    {:else if video}
        <video inline muted autoplay loop src="{video}" style="max-width: {maxWidth}px"></video>
    {/if}
    <div class="headline">{headline}</div>
    <div class="description">{description}</div>
    {#if what}
        <div class="what"><b>What I did:</b> {what}</div>
    {/if}
    {#if where}
        <div class="where"><b>Where:</b> {where}</div>
    {/if}
    {#if tools}
        <div class="tools"><b>Tools:</b> {tools}</div>
    {/if}
    <div class="clear"></div>
</div>